import React from 'react';
import PropTypes from 'prop-types';

import { GamedayLogo, Icon, Link, ShoppingCartIcon } from '../components/';
import { TranslatedCopy } from '../intl/TranslatedCopy';

import { selectedDepartmentTypes } from '../types/shop';

const AdminHeader = ({ isShopping, selectedDepartment, toggleIsAdminCart }) => (
  <div className='adminCart__header row align-center bg-white pt5-sm pb4-sm space-between'>
    <Link
      to='/orders/open'
      className='checkout__backToCart headline-5 flex-container row align-center'
      onClick={toggleIsAdminCart}
    >
      <Icon alt='back icon' name='chevron-left' />{' '}
      <span data-desc='checkout__header_admin'>
        <TranslatedCopy id='checkout.header.admin.back' />
      </span>
    </Link>
    <GamedayLogo />
    <div className='cart-container'>{selectedDepartment && isShopping && <ShoppingCartIcon />}</div>
  </div>
);

AdminHeader.defaultProps = {
  selectedDepartment: null,
  isShopping: false
};

AdminHeader.propTypes = {
  isShopping: PropTypes.bool,
  selectedDepartment: selectedDepartmentTypes,
  toggleIsAdminCart: PropTypes.func.isRequired
};

export default AdminHeader;
